function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ed626ba5-1887-49b9-8f13-bf83fd0ed615",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M40.92,4H19.08a4.2,4.2,0,0,0-4.2,4.2V51.84a4.2,4.2,0,0,0,4.2,4.2H40.92a4.2,4.2,0,0,0,4.2-4.2V8.16A4.2,4.2,0,0,0,40.92,4Zm2.52,47.88a2.52,2.52,0,0,1-2.52,2.52H19.08a2.52,2.52,0,0,1-2.52-2.52V44.28H43.44Zm0-9.24H16.56V12.36H43.44Zm0-31.92H16.56V8.16a2.52,2.52,0,0,1,2.52-2.52H40.92a2.52,2.52,0,0,1,2.52,2.52Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,51.84a2.52,2.52,0,1,0-2.52-2.52A2.52,2.52,0,0,0,30,51.84Zm0-3.36a.84.84,0,1,1-.84.84A.85.85,0,0,1,30,48.48Z"
})));

var SvgSettingsMobile = function SvgSettingsMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings_mobile.1a392abf.svg";
export { ForwardRef as ReactComponent };